/* bristm-contact-page — section script (loaded only where the section renders) */
(function () {
  function normaliseUrl(input) {
    var v = input.value.trim();
    /* "mystore.com" -> "https://mystore.com" so type=url validation accepts it */
    if (v && !/^[a-z][a-z0-9+.-]*:\/\//i.test(v)) input.value = 'https://' + v;
  }

  function init(scope) {
    var forms = (scope || document).querySelectorAll('[data-b-cpage-form]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.dataset.bBound) return;
      form.dataset.bBound = '1';

      var url = form.querySelector('[data-b-cpage-url]');
      if (url) {
        url.addEventListener('blur', function () {
          normaliseUrl(url);
        });
        /* capture phase: runs before the browser validates on submit */
        form.addEventListener(
          'click',
          function (e) {
            if (e.target.closest && e.target.closest('[type="submit"]')) normaliseUrl(url);
          },
          true
        );
      }

      form.addEventListener(
        'invalid',
        function (e) {
          var t = e.target;
          if (t.classList) t.classList.add('is-invalid');
          t.setAttribute('aria-invalid', 'true');
        },
        true
      );
      form.addEventListener('input', function (e) {
        var t = e.target;
        if (t.classList && t.classList.contains('is-invalid') && t.checkValidity()) {
          t.classList.remove('is-invalid');
          t.removeAttribute('aria-invalid');
        }
      });

      var notice = form.querySelector('[data-b-cpage-notice]');
      if (notice) {
        requestAnimationFrame(function () {
          notice.focus({ preventScroll: true });
          notice.scrollIntoView({ block: 'center' });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
